// extracted by mini-css-extract-plugin
export default {"tableLabel":"Table_tableLabel__OSRCn","tableValue":"Table_tableValue__YdQmg","tableValueBold":"Table_tableValueBold__hO+GL","capitalize":"Table_capitalize__qJpWT"};